// NOTE: Do not edit this file directly. This is generated automatically and will be
// rewritten as the source data changes. If there are required changes to this data,
// update the crops source data and/or reach out to the CDC Team.

import { CropConversions } from "./crops.models";

/**
 * Conversion data to be used for crop commodities
 */
export const CROP_CONVERSIONS: CropConversions = {
  "dc253162-85af-570e-80f7-c02174ab3093": {
    crop: "Alfalfa",
    baseUnit: "kg",
    locales: {
      "en-US": {
        "2a41ec1c-f9a2-5c56-9d8f-490d08610a02": {
          commodity: "Bales",
          imperial: {
            unit: "count",
            conversionFactor: 0.002204622622,
            unitI18nKey: "count",
          },
          metric: {
            unit: "count",
            conversionFactor: 0.002204622622,
            unitI18nKey: "count",
          },
        },
        "73286364-2101-5693-9ab6-86593b554977": {
          commodity: "Forage",
          imperial: {
            unit: "ton",
            conversionFactor: 0.001102311310924388,
            unitI18nKey: "ton",
          },
          metric: {
            unit: "kg",
            conversionFactor: 1,
            unitI18nKey: "kilogram",
          },
        },
        "bb6b081d-477b-5d34-b106-3e690fa3145b": {
          commodity: "Grazing",
          metric: {
            unit: "kg",
            conversionFactor: 1,
            unitI18nKey: "kilogram",
          },
        },
        "fcd7c76e-8f64-5325-94ba-0274563c7a41": {
          commodity: "Silage",
          imperial: {
            unit: "ton",
            conversionFactor: 0.001102311310924388,
            unitI18nKey: "ton",
          },
          metric: {
            unit: "tonne",
            conversionFactor: 0.001,
            unitI18nKey: "metric_ton",
          },
        },
      },
      "en-CA": {
        "2a41ec1c-f9a2-5c56-9d8f-490d08610a02": {
          commodity: "Bales",
          imperial: {
            unit: "count",
            conversionFactor: 0.002204622622,
            unitI18nKey: "count",
          },
          metric: {
            unit: "count",
            conversionFactor: 0.002204622622,
            unitI18nKey: "count",
          },
        },
        "73286364-2101-5693-9ab6-86593b554977": {
          commodity: "Forage",
          imperial: {
            unit: "ton",
            conversionFactor: 0.001102311310924388,
            unitI18nKey: "ton",
          },
          metric: {
            unit: "kg",
            conversionFactor: 1,
            unitI18nKey: "kilogram",
          },
        },
        "bb6b081d-477b-5d34-b106-3e690fa3145b": {
          commodity: "Grazing",
          metric: {
            unit: "kg",
            conversionFactor: 1,
            unitI18nKey: "kilogram",
          },
        },
        "fcd7c76e-8f64-5325-94ba-0274563c7a41": {
          commodity: "Silage",
          imperial: {
            unit: "ton",
            conversionFactor: 0.001102311310924388,
            unitI18nKey: "ton",
          },
          metric: {
            unit: "tonne",
            conversionFactor: 0.001,
            unitI18nKey: "metric_ton",
          },
        },
      },
      "fr-CA": {
        "2a41ec1c-f9a2-5c56-9d8f-490d08610a02": {
          commodity: "Balles",
          imperial: {
            unit: "count",
            conversionFactor: 0.002204622622,
            unitI18nKey: "count",
          },
          metric: {
            unit: "count",
            conversionFactor: 0.002204622622,
            unitI18nKey: "count",
          },
        },
        "73286364-2101-5693-9ab6-86593b554977": {
          commodity: "Fourrage",
          imperial: {
            unit: "ton",
            conversionFactor: 0.001102311310924388,
            unitI18nKey: "ton",
          },
          metric: {
            unit: "kg",
            conversionFactor: 1,
            unitI18nKey: "kilogram",
          },
        },
        "bb6b081d-477b-5d34-b106-3e690fa3145b": {
          commodity: "Pâturage",
          metric: {
            unit: "kg",
            conversionFactor: 1,
            unitI18nKey: "kilogram",
          },
        },
        "fcd7c76e-8f64-5325-94ba-0274563c7a41": {
          commodity: "Ensilage",
          imperial: {
            unit: "ton",
            conversionFactor: 0.001102311310924388,
            unitI18nKey: "ton",
          },
          metric: {
            unit: "tonne",
            conversionFactor: 0.001,
            unitI18nKey: "metric_ton",
          },
        },
      },
      "pt-BR": {
        "2a41ec1c-f9a2-5c56-9d8f-490d08610a02": {
          commodity: "Fardos",
          imperial: {
            unit: "count",
            conversionFactor: 0.002204622622,
            unitI18nKey: "count",
          },
          metric: {
            unit: "count",
            conversionFactor: 0.002204622622,
            unitI18nKey: "count",
          },
        },
        "73286364-2101-5693-9ab6-86593b554977": {
          commodity: "Forragem",
          imperial: {
            unit: "ton",
            conversionFactor: 0.001102311310924388,
            unitI18nKey: "ton",
          },
          metric: {
            unit: "kg",
            conversionFactor: 1,
            unitI18nKey: "kilogram",
          },
        },
        "bb6b081d-477b-5d34-b106-3e690fa3145b": {
          commodity: "Pasto",
          metric: {
            unit: "kg",
            conversionFactor: 1,
            unitI18nKey: "kilogram",
          },
        },
        "fcd7c76e-8f64-5325-94ba-0274563c7a41": {
          commodity: "Silagem",
          imperial: {
            unit: "ton",
            conversionFactor: 0.001102311310924388,
            unitI18nKey: "ton",
          },
          metric: {
            unit: "tonne",
            conversionFactor: 0.001,
            unitI18nKey: "metric_ton",
          },
        },
      },
    },
  },
  "86fcfa87-ef90-595a-8c08-b7c8660bd73b": {
    crop: "Canola",
    baseUnit: "kg",
    locales: {
      "en-US": {
        "62554676-f3a8-5eef-9c3d-ff0284e8d421": {
          commodity: "Grain",
          imperial: {
            unit: "bu",
            conversionFactor: 0.04409245244,
            unitI18nKey: "bushel",
          },
          metric: {
            unit: "tonne",
            conversionFactor: 0.001,
            unitI18nKey: "metric_ton",
          },
        },
        "4cca3c90-3d7e-523a-8a2a-97a24af026dc": {
          commodity: "Silage",
          imperial: {
            unit: "ton",
            conversionFactor: 0.001102311310924388,
            unitI18nKey: "ton",
          },
          metric: {
            unit: "tonne",
            conversionFactor: 0.001,
            unitI18nKey: "metric_ton",
          },
        },
      },
      "en-CA": {
        "62554676-f3a8-5eef-9c3d-ff0284e8d421": {
          commodity: "Grain",
          imperial: {
            unit: "bu",
            conversionFactor: 0.04409245244,
            unitI18nKey: "bushel",
          },
          metric: {
            unit: "kg",
            conversionFactor: 1,
            unitI18nKey: "kilogram",
          },
        },
        "4cca3c90-3d7e-523a-8a2a-97a24af026dc": {
          commodity: "Silage",
          imperial: {
            unit: "ton",
            conversionFactor: 0.001102311310924388,
            unitI18nKey: "ton",
          },
          metric: {
            unit: "tonne",
            conversionFactor: 0.001,
            unitI18nKey: "metric_ton",
          },
        },
      },
      "fr-CA": {
        "62554676-f3a8-5eef-9c3d-ff0284e8d421": {
          commodity: "Grain",
          imperial: {
            unit: "bu",
            conversionFactor: 0.04409245244,
            unitI18nKey: "bushel",
          },
          metric: {
            unit: "kg",
            conversionFactor: 1,
            unitI18nKey: "kilogram",
          },
        },
        "4cca3c90-3d7e-523a-8a2a-97a24af026dc": {
          commodity: "Ensilage",
          imperial: {
            unit: "ton",
            conversionFactor: 0.001102311310924388,
            unitI18nKey: "ton",
          },
          metric: {
            unit: "tonne",
            conversionFactor: 0.001,
            unitI18nKey: "metric_ton",
          },
        },
      },
      "pt-BR": {
        "62554676-f3a8-5eef-9c3d-ff0284e8d421": {
          commodity: "Grãos",
          imperial: {
            unit: "bu",
            conversionFactor: 0.002204622622,
            unitI18nKey: "bushel",
          },
          metric: {
            unit: "tonne",
            conversionFactor: 0.001,
            unitI18nKey: "metric_ton",
          },
        },
        "4cca3c90-3d7e-523a-8a2a-97a24af026dc": {
          commodity: "Silagem",
          imperial: {
            unit: "ton",
            conversionFactor: 0.001102311310924388,
            unitI18nKey: "ton",
          },
          metric: {
            unit: "tonne",
            conversionFactor: 0.001,
            unitI18nKey: "metric_ton",
          },
        },
      },
    },
  },
  "2946c5b5-ae45-57dc-8130-55edc4219f0b": {
    crop: "Corn",
    baseUnit: "kg",
    locales: {
      "en-US": {
        "c71a172f-73b9-5cfe-b175-d1a44e33ef85": {
          commodity: "Bales",
          imperial: {
            unit: "count",
            conversionFactor: 0.002204622622,
            unitI18nKey: "count",
          },
          metric: {
            unit: "count",
            conversionFactor: 0.002204622622,
            unitI18nKey: "count",
          },
        },
        "33cdf6d6-15d2-5458-a8a0-538a88502a26": {
          commodity: "Earlage",
          imperial: {
            unit: "bu",
            conversionFactor: 0.03149460888,
            unitI18nKey: "bushel",
          },
          metric: {
            unit: "kg",
            conversionFactor: 1,
            unitI18nKey: "kilogram",
          },
        },
        "6524ccbd-7706-5df1-a16b-f4835c3b0ab4": {
          commodity: "Grain",
          imperial: {
            unit: "bu",
            conversionFactor: 0.0393682611,
            unitI18nKey: "bushel",
          },
          metric: {
            unit: "tonne",
            conversionFactor: 0.001,
            unitI18nKey: "metric_ton",
          },
        },
        "5e417bda-94a5-59b9-bffe-85442fcc4d20": {
          commodity: "Silage",
          imperial: {
            unit: "ton",
            conversionFactor: 0.001102311310924388,
            unitI18nKey: "ton",
          },
          metric: {
            unit: "tonne",
            conversionFactor: 0.001,
            unitI18nKey: "metric_ton",
          },
        },
        "4a209d2c-3b82-539a-aa7e-75faebdf917b": {
          commodity: "Snaplage",
          imperial: {
            unit: "bu",
            conversionFactor: 0.03149460888,
            unitI18nKey: "bushel",
          },
          metric: {
            unit: "kg",
            conversionFactor: 1,
            unitI18nKey: "kilogram",
          },
        },
      },
      "en-CA": {
        "c71a172f-73b9-5cfe-b175-d1a44e33ef85": {
          commodity: "Bales",
          imperial: {
            unit: "count",
            conversionFactor: 0.002204622622,
            unitI18nKey: "count",
          },
          metric: {
            unit: "count",
            conversionFactor: 0.002204622622,
            unitI18nKey: "count",
          },
        },
        "33cdf6d6-15d2-5458-a8a0-538a88502a26": {
          commodity: "Earlage",
          imperial: {
            unit: "bu",
            conversionFactor: 0.03149460888,
            unitI18nKey: "bushel",
          },
          metric: {
            unit: "kg",
            conversionFactor: 1,
            unitI18nKey: "kilogram",
          },
        },
        "6524ccbd-7706-5df1-a16b-f4835c3b0ab4": {
          commodity: "Grain",
          imperial: {
            unit: "bu",
            conversionFactor: 0.0393682611,
            unitI18nKey: "bushel",
          },
          metric: {
            unit: "kg",
            conversionFactor: 1,
            unitI18nKey: "kilogram",
          },
        },
        "5e417bda-94a5-59b9-bffe-85442fcc4d20": {
          commodity: "Silage",
          imperial: {
            unit: "ton",
            conversionFactor: 0.001102311310924388,
            unitI18nKey: "ton",
          },
          metric: {
            unit: "tonne",
            conversionFactor: 0.001,
            unitI18nKey: "metric_ton",
          },
        },
        "4a209d2c-3b82-539a-aa7e-75faebdf917b": {
          commodity: "Snaplage",
          imperial: {
            unit: "bu",
            conversionFactor: 0.03149460888,
            unitI18nKey: "bushel",
          },
          metric: {
            unit: "kg",
            conversionFactor: 1,
            unitI18nKey: "kilogram",
          },
        },
      },
      "fr-CA": {
        "c71a172f-73b9-5cfe-b175-d1a44e33ef85": {
          commodity: "Balles",
          imperial: {
            unit: "count",
            conversionFactor: 0.002204622622,
            unitI18nKey: "count",
          },
          metric: {
            unit: "count",
            conversionFactor: 0.002204622622,
            unitI18nKey: "count",
          },
        },
        "33cdf6d6-15d2-5458-a8a0-538a88502a26": {
          commodity: "Ensilage d'épis de maïs",
          imperial: {
            unit: "bu",
            conversionFactor: 0.03149460888,
            unitI18nKey: "bushel",
          },
          metric: {
            unit: "kg",
            conversionFactor: 1,
            unitI18nKey: "kilogram",
          },
        },
        "6524ccbd-7706-5df1-a16b-f4835c3b0ab4": {
          commodity: "Grain",
          imperial: {
            unit: "bu",
            conversionFactor: 0.0393682611,
            unitI18nKey: "bushel",
          },
          metric: {
            unit: "kg",
            conversionFactor: 1,
            unitI18nKey: "kilogram",
          },
        },
        "5e417bda-94a5-59b9-bffe-85442fcc4d20": {
          commodity: "Ensilage",
          imperial: {
            unit: "ton",
            conversionFactor: 0.001102311310924388,
            unitI18nKey: "ton",
          },
          metric: {
            unit: "tonne",
            conversionFactor: 0.001,
            unitI18nKey: "metric_ton",
          },
        },
        "4a209d2c-3b82-539a-aa7e-75faebdf917b": {
          commodity: "Ensilage épi-hampe",
          imperial: {
            unit: "bu",
            conversionFactor: 0.03149460888,
            unitI18nKey: "bushel",
          },
          metric: {
            unit: "kg",
            conversionFactor: 1,
            unitI18nKey: "kilogram",
          },
        },
      },
      "pt-BR": {
        "c71a172f-73b9-5cfe-b175-d1a44e33ef85": {
          commodity: "Fardos",
          imperial: {
            unit: "count",
            conversionFactor: 0.002204622622,
            unitI18nKey: "count",
          },
          metric: {
            unit: "count",
            conversionFactor: 0.002204622622,
            unitI18nKey: "count",
          },
        },
        "33cdf6d6-15d2-5458-a8a0-538a88502a26": {
          commodity: "Espiga de Milho",
          imperial: {
            unit: "bu",
            conversionFactor: 0.03149460888,
            unitI18nKey: "bushel",
          },
          metric: {
            unit: "kg",
            conversionFactor: 1,
            unitI18nKey: "kilogram",
          },
        },
        "6524ccbd-7706-5df1-a16b-f4835c3b0ab4": {
          commodity: "Grãos",
          imperial: {
            unit: "bag",
            conversionFactor: 1000,
            unitI18nKey: "bag",
          },
          metric: {
            unit: "bag",
            conversionFactor: 1000,
            unitI18nKey: "bag",
          },
        },
        "5e417bda-94a5-59b9-bffe-85442fcc4d20": {
          commodity: "Silagem",
          imperial: {
            unit: "ton",
            conversionFactor: 0.001102311310924388,
            unitI18nKey: "ton",
          },
          metric: {
            unit: "tonne",
            conversionFactor: 0.001,
            unitI18nKey: "metric_ton",
          },
        },
        "4a209d2c-3b82-539a-aa7e-75faebdf917b": {
          commodity: "Silagem com Sabugo",
          imperial: {
            unit: "bu",
            conversionFactor: 0.03149460888,
            unitI18nKey: "bushel",
          },
          metric: {
            unit: "kg",
            conversionFactor: 1,
            unitI18nKey: "kilogram",
          },
        },
      },
    },
  },
  "29c8047e-38ba-5cd4-a44e-839c7074d6a7": {
    crop: "Cotton",
    baseUnit: "kg",
    locales: {
      "en-US": {
        "7088c905-9ad3-55fd-9b8c-079e6d92785f": {
          commodity: "Bales",
          imperial: {
            unit: "count",
            conversionFactor: 0.004409245244,
            unitI18nKey: "count",
          },
          metric: {
            unit: "count",
            conversionFactor: 0.004409245244,
            unitI18nKey: "count",
          },
        },
        "77d8d262-75a0-5811-9c19-c88ca2fd72b8": {
          commodity: "Fiber",
          imperial: {
            unit: "bu",
            conversionFactor: 0.06889445693,
            unitI18nKey: "bushel",
          },
          metric: {
            unit: "kg",
            conversionFactor: 1,
            unitI18nKey: "kilogram",
          },
        },
        "35d396cf-50f8-574d-9001-e47d4be04006": {
          commodity: "Stover",
          imperial: {
            unit: "bu",
            conversionFactor: 0.06889445693,
            unitI18nKey: "bushel",
          },
          metric: {
            unit: "kg",
            conversionFactor: 1,
            unitI18nKey: "kilogram",
          },
        },
      },
      "en-CA": {
        "7088c905-9ad3-55fd-9b8c-079e6d92785f": {
          commodity: "Bales",
          imperial: {
            unit: "count",
            conversionFactor: 0.004409245244,
            unitI18nKey: "count",
          },
          metric: {
            unit: "count",
            conversionFactor: 0.004409245244,
            unitI18nKey: "count",
          },
        },
        "77d8d262-75a0-5811-9c19-c88ca2fd72b8": {
          commodity: "Fibre",
          imperial: {
            unit: "bu",
            conversionFactor: 0.06889445693,
            unitI18nKey: "bushel",
          },
          metric: {
            unit: "kg",
            conversionFactor: 1,
            unitI18nKey: "kilogram",
          },
        },
        "35d396cf-50f8-574d-9001-e47d4be04006": {
          commodity: "Stover",
          imperial: {
            unit: "bu",
            conversionFactor: 0.06889445693,
            unitI18nKey: "bushel",
          },
          metric: {
            unit: "kg",
            conversionFactor: 1,
            unitI18nKey: "kilogram",
          },
        },
      },
      "fr-CA": {
        "7088c905-9ad3-55fd-9b8c-079e6d92785f": {
          commodity: "Balles",
          imperial: {
            unit: "count",
            conversionFactor: 0.004409245244,
            unitI18nKey: "count",
          },
          metric: {
            unit: "count",
            conversionFactor: 0.004409245244,
            unitI18nKey: "count",
          },
        },
        "77d8d262-75a0-5811-9c19-c88ca2fd72b8": {
          commodity: "Fibre",
          imperial: {
            unit: "bu",
            conversionFactor: 0.06889445693,
            unitI18nKey: "bushel",
          },
          metric: {
            unit: "kg",
            conversionFactor: 1,
            unitI18nKey: "kilogram",
          },
        },
        "35d396cf-50f8-574d-9001-e47d4be04006": {
          commodity: "Paille",
          imperial: {
            unit: "bu",
            conversionFactor: 0.06889445693,
            unitI18nKey: "bushel",
          },
          metric: {
            unit: "kg",
            conversionFactor: 1,
            unitI18nKey: "kilogram",
          },
        },
      },
      "pt-BR": {
        "7088c905-9ad3-55fd-9b8c-079e6d92785f": {
          commodity: "Fardos",
          imperial: {
            unit: "count",
            conversionFactor: 0.004409245244,
            unitI18nKey: "count",
          },
          metric: {
            unit: "count",
            conversionFactor: 0.004409245244,
            unitI18nKey: "count",
          },
        },
        "77d8d262-75a0-5811-9c19-c88ca2fd72b8": {
          commodity: "Fibra",
          imperial: {
            unit: "bu",
            conversionFactor: 0.06889445693,
            unitI18nKey: "bushel",
          },
          metric: {
            unit: "kg",
            conversionFactor: 1,
            unitI18nKey: "kilogram",
          },
        },
        "35d396cf-50f8-574d-9001-e47d4be04006": {
          commodity: "Palha",
          imperial: {
            unit: "bu",
            conversionFactor: 0.06889445693,
            unitI18nKey: "bushel",
          },
          metric: {
            unit: "kg",
            conversionFactor: 1,
            unitI18nKey: "kilogram",
          },
        },
      },
    },
  },
  "499dbe00-5146-5a9a-b00b-b2b969c1d229": {
    crop: "Sorghum",
    baseUnit: "kg",
    locales: {
      "en-US": {
        "a3713b16-e5a5-5f73-a0ef-c15dc5133b07": {
          commodity: "Forage",
          imperial: {
            unit: "ton",
            conversionFactor: 0.001102311310924388,
            unitI18nKey: "ton",
          },
          metric: {
            unit: "kg",
            conversionFactor: 1,
            unitI18nKey: "kilogram",
          },
        },
        "c3d2a446-6b29-532a-8f28-045e6f28e774": {
          commodity: "Grain",
          imperial: {
            unit: "bu",
            conversionFactor: 0.04409245244,
            unitI18nKey: "bushel",
          },
          metric: {
            unit: "tonne",
            conversionFactor: 0.001,
            unitI18nKey: "metric_ton",
          },
        },
      },
      "en-CA": {
        "a3713b16-e5a5-5f73-a0ef-c15dc5133b07": {
          commodity: "Forage",
          imperial: {
            unit: "bu",
            conversionFactor: 0.002204622622,
            unitI18nKey: "bushel",
          },
          metric: {
            unit: "kg",
            conversionFactor: 1,
            unitI18nKey: "kilogram",
          },
        },
        "c3d2a446-6b29-532a-8f28-045e6f28e774": {
          commodity: "Grain",
          imperial: {
            unit: "bu",
            conversionFactor: 0.002204622622,
            unitI18nKey: "bushel",
          },
          metric: {
            unit: "kg",
            conversionFactor: 1,
            unitI18nKey: "kilogram",
          },
        },
      },
      "fr-CA": {
        "a3713b16-e5a5-5f73-a0ef-c15dc5133b07": {
          commodity: "Fourrage",
          imperial: {
            unit: "bu",
            conversionFactor: 0.002204622622,
            unitI18nKey: "bushel",
          },
          metric: {
            unit: "kg",
            conversionFactor: 1,
            unitI18nKey: "kilogram",
          },
        },
        "c3d2a446-6b29-532a-8f28-045e6f28e774": {
          commodity: "Grain",
          imperial: {
            unit: "bu",
            conversionFactor: 0.002204622622,
            unitI18nKey: "bushel",
          },
          metric: {
            unit: "kg",
            conversionFactor: 1,
            unitI18nKey: "kilogram",
          },
        },
      },
      "pt-BR": {
        "a3713b16-e5a5-5f73-a0ef-c15dc5133b07": {
          commodity: "Forragem",
          imperial: {
            unit: "lbs",
            conversionFactor: 2.2046226218487757,
            unitI18nKey: "pound",
          },
          metric: {
            unit: "tonne",
            conversionFactor: 0.001,
            unitI18nKey: "metric_ton",
          },
        },
        "c3d2a446-6b29-532a-8f28-045e6f28e774": {
          commodity: "Grãos",
          imperial: {
            unit: "bag",
            conversionFactor: 1000,
            unitI18nKey: "bag",
          },
          metric: {
            unit: "bag",
            conversionFactor: 1000,
            unitI18nKey: "bag",
          },
        },
      },
    },
  },
  "dc7e2b80-8d11-5b71-8309-b8b7b2e2598b": {
    crop: "Soybeans",
    baseUnit: "kg",
    locales: {
      "en-US": {
        "ad683872-d40b-57be-bfb7-9e3ed7cab15f": {
          commodity: "Bales",
          imperial: {
            unit: "count",
            conversionFactor: 0.002204622622,
            unitI18nKey: "count",
          },
          metric: {
            unit: "count",
            conversionFactor: 0.002204622622,
            unitI18nKey: "count",
          },
        },
        "d68584ab-6fbf-5d6e-89d2-bdab8e7cade6": {
          commodity: "Grain",
          imperial: {
            unit: "bu",
            conversionFactor: 0.03674371036,
            unitI18nKey: "bushel",
          },
          metric: {
            unit: "tonne",
            conversionFactor: 0.001,
            unitI18nKey: "metric_ton",
          },
        },
        "129d7eb2-6a7b-5e1a-b5ed-044ae9a2731e": {
          commodity: "Market",
          imperial: {
            unit: "bu",
            conversionFactor: 0.03674371036,
            unitI18nKey: "bushel",
          },
          metric: {
            unit: "kg",
            conversionFactor: 1,
            unitI18nKey: "kilogram",
          },
        },
        "e1473075-ba26-54fc-ae0a-ca69625288dd": {
          commodity: "Silage",
          imperial: {
            unit: "ton",
            conversionFactor: 0.001102311310924388,
            unitI18nKey: "ton",
          },
          metric: {
            unit: "tonne",
            conversionFactor: 0.001,
            unitI18nKey: "metric_ton",
          },
        },
      },
      "en-CA": {
        "ad683872-d40b-57be-bfb7-9e3ed7cab15f": {
          commodity: "Bales",
          imperial: {
            unit: "count",
            conversionFactor: 0.002204622622,
            unitI18nKey: "count",
          },
          metric: {
            unit: "count",
            conversionFactor: 0.002204622622,
            unitI18nKey: "count",
          },
        },
        "d68584ab-6fbf-5d6e-89d2-bdab8e7cade6": {
          commodity: "Grain",
          imperial: {
            unit: "bu",
            conversionFactor: 0.03674371036,
            unitI18nKey: "bushel",
          },
          metric: {
            unit: "kg",
            conversionFactor: 1,
            unitI18nKey: "kilogram",
          },
        },
        "129d7eb2-6a7b-5e1a-b5ed-044ae9a2731e": {
          commodity: "Market",
          imperial: {
            unit: "bu",
            conversionFactor: 0.03674371036,
            unitI18nKey: "bushel",
          },
          metric: {
            unit: "kg",
            conversionFactor: 1,
            unitI18nKey: "kilogram",
          },
        },
        "e1473075-ba26-54fc-ae0a-ca69625288dd": {
          commodity: "Silage",
          imperial: {
            unit: "ton",
            conversionFactor: 0.001102311310924388,
            unitI18nKey: "ton",
          },
          metric: {
            unit: "tonne",
            conversionFactor: 0.001,
            unitI18nKey: "metric_ton",
          },
        },
      },
      "fr-CA": {
        "ad683872-d40b-57be-bfb7-9e3ed7cab15f": {
          commodity: "Balles",
          imperial: {
            unit: "count",
            conversionFactor: 0.002204622622,
            unitI18nKey: "count",
          },
          metric: {
            unit: "count",
            conversionFactor: 0.002204622622,
            unitI18nKey: "count",
          },
        },
        "d68584ab-6fbf-5d6e-89d2-bdab8e7cade6": {
          commodity: "Grain",
          imperial: {
            unit: "bu",
            conversionFactor: 0.03674371036,
            unitI18nKey: "bushel",
          },
          metric: {
            unit: "kg",
            conversionFactor: 1,
            unitI18nKey: "kilogram",
          },
        },
        "129d7eb2-6a7b-5e1a-b5ed-044ae9a2731e": {
          commodity: "Marché",
          imperial: {
            unit: "bu",
            conversionFactor: 0.03674371036,
            unitI18nKey: "bushel",
          },
          metric: {
            unit: "kg",
            conversionFactor: 1,
            unitI18nKey: "kilogram",
          },
        },
        "e1473075-ba26-54fc-ae0a-ca69625288dd": {
          commodity: "Ensilage",
          imperial: {
            unit: "ton",
            conversionFactor: 0.001102311310924388,
            unitI18nKey: "ton",
          },
          metric: {
            unit: "tonne",
            conversionFactor: 0.001,
            unitI18nKey: "metric_ton",
          },
        },
      },
      "pt-BR": {
        "ad683872-d40b-57be-bfb7-9e3ed7cab15f": {
          commodity: "Fardos",
          imperial: {
            unit: "count",
            conversionFactor: 0.002204622622,
            unitI18nKey: "count",
          },
          metric: {
            unit: "count",
            conversionFactor: 0.002204622622,
            unitI18nKey: "count",
          },
        },
        "d68584ab-6fbf-5d6e-89d2-bdab8e7cade6": {
          commodity: "Grãos",
          imperial: {
            unit: "bag",
            conversionFactor: 1000,
            unitI18nKey: "bag",
          },
          metric: {
            unit: "bag",
            conversionFactor: 1000,
            unitI18nKey: "bag",
          },
        },
        "129d7eb2-6a7b-5e1a-b5ed-044ae9a2731e": {
          commodity: "Mercado",
          imperial: {
            unit: "bu",
            conversionFactor: 0.03674371036,
            unitI18nKey: "bushel",
          },
          metric: {
            unit: "kg",
            conversionFactor: 1,
            unitI18nKey: "kilogram",
          },
        },
        "e1473075-ba26-54fc-ae0a-ca69625288dd": {
          commodity: "Silagem",
          imperial: {
            unit: "ton",
            conversionFactor: 0.001102311310924388,
            unitI18nKey: "ton",
          },
          metric: {
            unit: "tonne",
            conversionFactor: 0.001,
            unitI18nKey: "metric_ton",
          },
        },
      },
    },
  },
  "0d035a8f-00f7-5cc9-9cd0-82133719d6a7": {
    crop: "Sunflowers",
    baseUnit: "kg",
    locales: {
      "en-US": {
        "a26bc91d-10d5-5a00-b3b2-8c4930df6d06": {
          commodity: "Grain",
          imperial: {
            unit: "bu",
            conversionFactor: 0.09185927591,
            unitI18nKey: "bushel",
          },
          metric: {
            unit: "kg",
            conversionFactor: 1,
            unitI18nKey: "kilogram",
          },
        },
      },
      "en-CA": {
        "a26bc91d-10d5-5a00-b3b2-8c4930df6d06": {
          commodity: "Grain",
          imperial: {
            unit: "bu",
            conversionFactor: 0.002204622622,
            unitI18nKey: "bushel",
          },
          metric: {
            unit: "kg",
            conversionFactor: 1,
            unitI18nKey: "kilogram",
          },
        },
      },
      "fr-CA": {
        "a26bc91d-10d5-5a00-b3b2-8c4930df6d06": {
          commodity: "Grain",
          imperial: {
            unit: "bu",
            conversionFactor: 0.002204622622,
            unitI18nKey: "bushel",
          },
          metric: {
            unit: "kg",
            conversionFactor: 1,
            unitI18nKey: "kilogram",
          },
        },
      },
      "pt-BR": {
        "a26bc91d-10d5-5a00-b3b2-8c4930df6d06": {
          commodity: "Grãos",
          imperial: {
            unit: "lbs",
            conversionFactor: 2.2046226218487757,
            unitI18nKey: "pound",
          },
          metric: {
            unit: "tonne",
            conversionFactor: 0.001,
            unitI18nKey: "metric_ton",
          },
        },
      },
    },
  },
  "d7a656bc-e729-5cd5-800e-1e85770e6416": {
    crop: "Wheat",
    baseUnit: "kg",
    locales: {
      "en-US": {
        "5cb90bc0-35ac-5066-a86b-ed8db421611f": {
          commodity: "Bales",
          imperial: {
            unit: "count",
            conversionFactor: 0.002204622622,
            unitI18nKey: "count",
          },
          metric: {
            unit: "count",
            conversionFactor: 0.002204622622,
            unitI18nKey: "count",
          },
        },
        "16cb05a2-55d6-5190-89c3-1740810a6ccf": {
          commodity: "Grain",
          imperial: {
            unit: "bu",
            conversionFactor: 0.03674371036,
            unitI18nKey: "bushel",
          },
          metric: {
            unit: "tonne",
            conversionFactor: 0.001,
            unitI18nKey: "metric_ton",
          },
        },
        "9c291530-78a1-5c77-8f49-ec93e91f84b2": {
          commodity: "Silage",
          imperial: {
            unit: "ton",
            conversionFactor: 0.001102311310924388,
            unitI18nKey: "ton",
          },
          metric: {
            unit: "tonne",
            conversionFactor: 0.001,
            unitI18nKey: "metric_ton",
          },
        },
      },
      "en-CA": {
        "5cb90bc0-35ac-5066-a86b-ed8db421611f": {
          commodity: "Bales",
          imperial: {
            unit: "count",
            conversionFactor: 0.002204622622,
            unitI18nKey: "count",
          },
          metric: {
            unit: "count",
            conversionFactor: 0.002204622622,
            unitI18nKey: "count",
          },
        },
        "16cb05a2-55d6-5190-89c3-1740810a6ccf": {
          commodity: "Grain",
          imperial: {
            unit: "bu",
            conversionFactor: 0.03674371036,
            unitI18nKey: "bushel",
          },
          metric: {
            unit: "kg",
            conversionFactor: 1,
            unitI18nKey: "kilogram",
          },
        },
        "9c291530-78a1-5c77-8f49-ec93e91f84b2": {
          commodity: "Silage",
          imperial: {
            unit: "ton",
            conversionFactor: 0.001102311310924388,
            unitI18nKey: "ton",
          },
          metric: {
            unit: "tonne",
            conversionFactor: 0.001,
            unitI18nKey: "metric_ton",
          },
        },
      },
      "fr-CA": {
        "5cb90bc0-35ac-5066-a86b-ed8db421611f": {
          commodity: "Balles",
          imperial: {
            unit: "count",
            conversionFactor: 0.002204622622,
            unitI18nKey: "count",
          },
          metric: {
            unit: "count",
            conversionFactor: 0.002204622622,
            unitI18nKey: "count",
          },
        },
        "16cb05a2-55d6-5190-89c3-1740810a6ccf": {
          commodity: "Grain",
          imperial: {
            unit: "bu",
            conversionFactor: 0.03674371036,
            unitI18nKey: "bushel",
          },
          metric: {
            unit: "kg",
            conversionFactor: 1,
            unitI18nKey: "kilogram",
          },
        },
        "9c291530-78a1-5c77-8f49-ec93e91f84b2": {
          commodity: "Ensilage",
          imperial: {
            unit: "ton",
            conversionFactor: 0.001102311310924388,
            unitI18nKey: "ton",
          },
          metric: {
            unit: "tonne",
            conversionFactor: 0.001,
            unitI18nKey: "metric_ton",
          },
        },
      },
      "pt-BR": {
        "5cb90bc0-35ac-5066-a86b-ed8db421611f": {
          commodity: "Fardos",
          imperial: {
            unit: "count",
            conversionFactor: 0.002204622622,
            unitI18nKey: "count",
          },
          metric: {
            unit: "count",
            conversionFactor: 0.002204622622,
            unitI18nKey: "count",
          },
        },
        "16cb05a2-55d6-5190-89c3-1740810a6ccf": {
          commodity: "Grãos",
          metric: {
            unit: "tonne",
            conversionFactor: 0.001,
            unitI18nKey: "metric_ton",
          },
        },
        "9c291530-78a1-5c77-8f49-ec93e91f84b2": {
          commodity: "Silagem",
          imperial: {
            unit: "ton",
            conversionFactor: 0.001102311310924388,
            unitI18nKey: "ton",
          },
          metric: {
            unit: "tonne",
            conversionFactor: 0.001,
            unitI18nKey: "metric_ton",
          },
        },
      },
    },
  },
};
